import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';
import { useModalService } from './../../../ricos-modals/modal-service-provider';
import type { IToolbarItem, Placement } from './../../../ricos-types';
import { ToggleButton } from './../../../toolbars-ui';
import { FormattingToolbar } from './../../../toolbars-v3/ricos-toolbars';
import { FormattingIcon } from './../../../ui-components';

import { ROOT } from '../../data-hooks';

const FORMATTING_TOOLBAR_MODAL_ID = 'ricos-formatting-toolbar';
interface Props {
  toolbarItem: IToolbarItem;
  dataHook?: string;
}

export const FormattingButton: FC<Props> = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const placement: Placement = 'top-start';

  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);

  const openModal = () => {
    const isModalOpen = modalService.isModalOpen(FORMATTING_TOOLBAR_MODAL_ID);

    if (isModalOpen) {
      modalService.closeModal(FORMATTING_TOOLBAR_MODAL_ID);
      return;
    }

    modalService.openModal({
      id: FORMATTING_TOOLBAR_MODAL_ID,
      Component: FormattingToolbar,
      layout: 'toolbar',
      positioning: { referenceElement, placement },
      componentProps: {
        maxWidth: toolbarItem.attributes.maxWidth,
      },
      onClickOutside: e => {
        const targetElement = e.target as Element;
        const hasClosest = 'closest' in targetElement;
        if (
          !referenceElement?.isConnected ||
          (hasClosest && targetElement?.closest(`[data-hook=${ROOT}]`))
        ) {
          modalService.closeModal(FORMATTING_TOOLBAR_MODAL_ID);
        }
      },
    });
  };

  return (
    <ToggleButton
      setRef={setReferenceElement}
      Icon={FormattingIcon}
      onClick={openModal}
      dataHook={dataHook}
      tooltip={t('TablePlugin_Toolbar_TextStyle_Button')}
    />
  );
};
